import { Navigate, useRouterState } from "@tanstack/react-router";
import { usePermissions } from "@/shared/hooks/usePermissions";
import { permissionForRoute } from "@/shared/components/sidebar/routePermissionRegistry";

export function MfeMount() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const { permissions } = usePermissions();

  const required = permissionForRoute(pathname);
  const denied =
    required != null &&
    permissions.length > 0 &&
    !permissions.some((p) => p.name === required && p.active);

  if (denied) {
    return <Navigate to="/access-denied" />;
  }

  // The MFE mount node (#single-spa-app-container) is owned by the root chrome
  // (__root.tsx) as a stable, absolutely-positioned box filling the content
  // area. This route only gates access; it must not render a second container.
  return null;
}
